<template>
    <v-layout>
        <v-flex xs8>
            <text-area-label
                ref="copy-text"
                v-model="value"
                :rules="rulesData"
                :disabled="disabled"
                is-read-only
                class="text-subtitle-2 px-2"
            />
        </v-flex>
        <v-flex xs4>
            <v-tooltip :right="isRight">
                <template v-slot:activator="{ on }">
                    <button-app-control
                        ref="copy-btn"
                        :color="color"
                        :icon="'fa-copy'"
                        :disabled="disabled"
                        text
                        @click="$emit('copy-text', value)"
                        v-on="on"
                    />
                </template>
                <span>
                    {{ $t('Copy') }}
                </span>
            </v-tooltip>
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import ButtonAppControl from './ButtonAppControl.vue';
import TextAreaLabel from './TextAreaLabel.vue';
import { shallowCopy } from '../../utils/types/utility';

@Component({
    name: 'TextAreaClipboard',
    components: {
        ButtonAppControl,
        TextAreaLabel,
    },
})
export default class TextAreaClipboard extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: [] }) rules: Array<any>;
    @Prop({ default: '' }) appendIcon: string;
    @Prop({ default: false }) small: boolean;
    @Prop({ default: false }) outlined: boolean;
    @Prop({ default: false }) right: boolean;
    @Prop({ default: 'brack' }) color: string;
    @Prop({ default: false }) isIconShow: boolean;
    @Prop({ default: false }) disabled: boolean;

    get isRight(): boolean {
        return this.right;
    }
    get rulesData(): Array<any> {
        return this.rules;
    }
}
</script>
